import { IPaginatedResponse } from '@boma/client-shared';
import {
  ILocation,
  IOrder,
  IOrderMessage,
  IVehicle,
  OrderDirection,
  OrderEventStatus,
} from '@boma/supplier-portal/shared/entities';
import { createAction, props } from '@ngrx/store';

export const loadSales = createAction('[Sales] Load Sales');

export const loadSalesSuccess = createAction(
  '[Sales] Load Sales Success',
  props<{ payload: IPaginatedResponse<IOrder> }>()
);

export const loadSalesFailure = createAction(
  '[Sales] Load Sales Failure',
  props<{ error: any }>()
);

export const updateSaleSearchParams = createAction(
  '[Sales] Update Inventory Search Parameters',
  props<{
    query: string;
    locationIds: string[];
    locationType: string;
    orderDirection: OrderDirection;
    status?: OrderEventStatus | null;
    statuses?: string[];
    customerIds: string[];
    dateRange: { fromDate: string; toDate: string };
    orderType: string;
  }>()
);

export const loadSaleDetails = createAction(
  '[Sales] Load Sale Details',
  props<{ id: string }>()
);

export const loadSaleDetailsSuccess = createAction(
  '[Sales] Load Sale Details Success',
  props<{ order: IOrder }>()
);

export const loadSaleDetailsFailure = createAction(
  '[Sales] Load Sale Details Failure',
  props<{ error: any }>()
);

export const loadSaleLocations = createAction(
  '[Sales] Load Locations',
  props<{
    locationType: string;
    query: string;
    defaultOption: IVehicle | ILocation;
  }>()
);
export const loadSaleLocationsFailure = createAction(
  '[Sales] Load Locations Failure',
  props<{ error: any }>()
);

export const loadSaleLocationsSuccess = createAction(
  '[Sales] Load Locations Success',
  props<{ payload: ILocation[] | IVehicle[] }>()
);

export const updateSaleStatusToCancelled = createAction(
  '[Sales] Update Order Status To Cancelled',
  props<{ id: string; comment: string; direction: OrderDirection }>()
);

export const loadSaleMessages = createAction(
  '[Sales] Load Sale Messages',
  props<{ id: string; direction: OrderDirection }>()
);

export const loadSaleMessagesSuccess = createAction(
  '[Sales] Load Sale Message Success',
  props<{ payload: IOrderMessage[] }>()
);

export const loadSaleMessagesFailure = createAction(
  '[Sales] Load Sale Messages Failure',
  props<{ error: any }>()
);

export const createSaleMessage = createAction(
  '[Sales] Create Sale Messages',
  props<{ id: string; direction: OrderDirection; content: string }>()
);

export const createSaleMessageSuccess = createAction(
  '[Sales] Create Sale Message Success',
  props<{ message: IOrderMessage }>()
);

export const createSaleMessageFailure = createAction(
  '[Sales] Create Sale Messages Failure',
  props<{ error: any }>()
);
